import { logger } from 'lib/logger';
import { getCheckAb } from 'reactApp/api/axios.corsapi';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { CHECK_AB_CONFIG, IS_CHECK_AB } from 'reactApp/appHelpers/featuresHelpers/features/checkAB';
import { getIsAllowedDevice, getIsUserEnabled } from 'reactApp/modules/checkAB/checkAB.helpers';
import { getCheckABFailure, getCheckABRequest, getCheckABSuccess } from 'reactApp/modules/checkAB/checkAB.module';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';
import { call, put, select, takeLatest } from 'redux-saga/effects';

enum ClientNameType {
    Web = 'cloud-web',
    MWeb = 'cloud-mweb',
}

function* handleCheckAb() {
    try {
        const email = yield select(UserSelectors.getEmail);
        const storage = yield select(getCurrentStorage);
        const { queryEnabled, queryEnabledForEmbedded, webViewEnabled, iframeEnabled, promoQuotaEnabled, queryEnabledForSocial } =
            CHECK_AB_CONFIG;
        const { isPromoQuota, isEmbedded } = getStorage(storage);

        const isBizUser = yield select(UserSelectors.isBizUser);
        const isCorpUser = yield select(UserSelectors.isCorpUser);
        const isSocialUser = yield select(UserSelectors.isSocialUser);
        const isVKIDSocialUser = yield select(UserSelectors.isVKIDSocialUser);
        const isAllowedUser = getIsUserEnabled({ isBizUser, isCorpUser, isSocialUser, isVKIDSocialUser });

        const isMobile = yield select(EnvironmentSelectors.isMobile);
        const clientName = isMobile ? ClientNameType.MWeb : ClientNameType.Web;
        const isAllowedDevice = getIsAllowedDevice(isMobile);

        const isWebview = yield select(EnvironmentSelectors.isWebview);
        const isIFrame = yield select(EnvironmentSelectors.isIFrame);
        const isEmbedding = isWebview || isIFrame || isEmbedded || isPromoQuota;
        const isAllowedEmbeddingForSuccess =
            !isEmbedding || (isWebview && webViewEnabled) || (isIFrame && iframeEnabled) || (isPromoQuota && promoQuotaEnabled);

        if (IS_ONPREMISE) {
            return;
        }
        if (!queryEnabled) {
            return;
        }
        if (isEmbedding && !queryEnabledForEmbedded) {
            return;
        }
        if ((isSocialUser || isVKIDSocialUser) && !queryEnabledForSocial) {
            return;
        }

        const data = yield call(getCheckAb, { email, client_name: clientName });

        const newmetrics = data?.newmetrics || false;

        sendDwh({
            eventCategory: ECategoryGa.vpn,
            action: 'detect',
            dwhData: {
                vpn_check_enabled: IS_CHECK_AB,
                platform: isMobile ? 'touch' : 'web',
                webview: isWebview,
                is_vpn: newmetrics ? newmetrics : false,
                storage,
            },
            dwh_enabled: true,
            dwh_enabled_fields: [['is_vpn', 'platform', 'storage']],
        });

        const canSuccess = isAllowedEmbeddingForSuccess && isAllowedDevice && isAllowedUser && newmetrics && IS_CHECK_AB;

        if (canSuccess) {
            yield put(getCheckABSuccess());
        } else {
            yield put(getCheckABFailure());
        }
    } catch (error) {
        logger.error(error);
    }
}

export function* watchCheckAb() {
    yield takeLatest(getCheckABRequest.toString(), handleCheckAb);
}
